import { Panel } from '@epam/promo';
import { FormBody } from '../FormBody';
import { RecognitionHeader } from '../RecognitionHeader';
import css from './RecognitionForm.module.scss';

export const RecognitionForm = () => (
  <Panel shadow cx={css.page__container}>
    <RecognitionHeader />
    <FormBody />
  </Panel>
);
